<app-nav-bar [searchBar]="false" [sideMenu]="false"></app-nav-bar>
<div class="cont">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 dataCont">
        <h1 class="header">{{ "downloadApp" | translate }}</h1>
        <p class="desc">
          Now Booky is available in Google & Huawei Stores Download Application
          Now
        </p>
        <div class="images">
          <a
            href="https://play.google.com/store/apps/details?id=com.scorpion.booky"
            class="linkImg"
          >
            <img src="assets/images/google-play-logo.jpeg" alt="" />
          </a>
          <a
            href="https://appgallery.huawei.com/app/C104083907"
            class="linkImg"
          >
            <img src="assets/images/appGalleryLogo.png" alt="" />
          </a>
        </div>
      </div>
      <div class="col-lg-6 col-md-9 imgCont">
        <img src="assets/images/mobileMock.jpeg" class="img" />
      </div>
    </div>
  </div>
</div>
